import React from "react";
import "./Admin.css";
import Tickets from "../Tickets/Tickets";
import Recipients from "../Recipients/Recipients";

class Admin extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selected: "tickets"
        }

        this.updateSelected = this.updateSelected.bind(this);
        this.renderSelected = this.renderSelected.bind(this);
    }

    updateSelected(event) {
        let selection = event.target.id.split("-")[1];
        if(this.state.selected !== selection) {
            document.getElementById(`admin-${this.state.selected}`).className = "admin-subnav";
            this.setState({selected: selection});
            event.target.className = "admin-subnav selected";
        }
    }

    renderSelected() {
        switch(this.state.selected) {
            case "tickets":
                return <Tickets getUser={this.props.get}/>;
                
            case "recipients":
                return <Recipients/>;

            default:
                return <Tickets/>;
        }
    }

    render() {
        return (
            <div id="admin">
                <div className="admin-nav">
                    <p id="admin-tickets" onClick={this.updateSelected} className="admin-subnav selected">Tickets</p>
                    <p id="admin-recipients" onClick={this.updateSelected} className="admin-subnav">Recipients</p>
                    
                </div>
                <div className="admin-body">
                {this.renderSelected()}
                </div>
            </div>
        );
    }
}

export default Admin;